<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CxwOzO/tc-custom/9780253016409.jpg?1717895902588" alt="This image is the cover for the book African Appropriations, African Expressive Cultures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">African Appropriations, African Expressive Cultures
      </h1>
      <p class="bookDescription body article font2">
        <b>This exploration of African adaptations of global pop culture is “a genuinely innovative book unlike most others in either anthropology or African studies” (<i>American Ethnologist</i>).</b><br/><br/>Why would a Hollywood film become a Nigerian video remake, a Tanzanian comic book, or a Congolese music video? Matthias Krings explores the myriad ways Africans respond to the relentless onslaught of global culture. He seeks out places where they have adapted pervasive cultural forms to their own purposes as photo novels, comic books, songs, posters, and even scam letters.<br/><br/>These African appropriations reveal the broad scope of cultural mediation that is characteristic of our hyperlinked age. Krings argues that there is no longer an “original” or “faithful copy,” but only endless transformations that thrive in the fertile ground of African popular culture.<br/><br/>“The text is jargon free, a pleasure to read, remarkably well researched, and enriched by 40 illustrations . . . Highly recommended.” —<i>Choice</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthias Krings
      </h2>
      
      <p class="authorDescription body article"><P>Matthias Krings is Professor of Anthropology and African Popular Culture at Johannes Gutenberg University in Mainz. He is editor (with Onookome Okome) of Global Nollywood: The Transnational Dimensions of an African Video Film Industry (IUP, 2013).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5fbcbc6a